import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ShoppingCartItem } from "@mjolnerbacken/shared/types/shopping-cart-item";
import { useEffect, useRef, useState } from "react";

import { useShoppingCart } from "../hooks/shopping-cart";
import { Input } from "./input";
import { PrimeButton } from "./prime/button";

export function ShoppingItem({ item }: { item: ShoppingCartItem }) {
  const [inputChecked, setInputChecked] = useState(item.checked);
  const [inputValue, setInputValue] = useState(item.value);
  const [editMode, setEditMode] = useState(false);
  const {
    updateItem: updateShoppingCartItem,
    deleteItem: deleteShoppingCartItem,
  } = useShoppingCart();

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setInputValue(item.value);
  }, [item.value]);

  useEffect(() => {
    setInputChecked(item.checked);
  }, [item.checked]);

  const updateValue = () => {
    setEditMode(false);
    updateShoppingCartItem({
      id: item.id,
      item: {
        value: inputValue,
      },
    });
  };

  return (
    <li className="flex items-center gap-4 px-3 py-2 bg-gray-50 shadow-sm">
      <input
        checked={inputChecked}
        className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        type="checkbox"
        onChange={() => {
          setInputChecked(!inputChecked);
          updateShoppingCartItem({
            id: item.id,
            item: {
              checked: !inputChecked,
            },
          });
        }}
      />
      {editMode ? (
        <Input
          ref={inputRef}
          className="grow !m-0"
          inputClassName="!w-full relative left-[-1px]"
          size="mini"
          type="text"
          value={inputValue}
          onBlur={updateValue}
          onChange={(e) => {
            setInputValue(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              updateValue();
            }
          }}
        />
      ) : (
        <button
          className={`text-left grow text-gray-800 ${inputChecked ? "line-through" : ""}`}
          onClick={() => {
            setEditMode(true);
            setTimeout(() => {
              inputRef.current?.focus();
            }, 0);
          }}
        >
          {inputValue}
        </button>
      )}
      <PrimeButton
        icon={<FontAwesomeIcon icon={faTrash} size="xs" />}
        severity="danger"
        size="small"
        onClick={() => {
          deleteShoppingCartItem(item.id);
        }}
      />
    </li>
  );
}
